import '../scss/main.scss';

import { hamburger } from './components/hamburger';
import { parallax } from './components/parallax';
import { makeSpacers } from './components/makeSpacers';
import { followMenu } from './components/followMenu';



/* Defining Site URL for images, so the website works on subfolder wordpress instances as well as global/absolute instances */
if (typeof themeSettings !== 'undefined') {
  __webpack_public_path__ = `${themeSettings.baseUrl}/wp-content/themes/heritagehipz/dist/images/`;
}
document.addEventListener("DOMContentLoaded", () => {
  hamburger();
  parallax();
  makeSpacers();
  followMenu();
}) 
